import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useInstanceId } from 'shared/src/hooks';
import { putAddress } from 'mypage/src/api/addressService';
import { queryKey } from '../../../constant/queryKey';

export const usePutAddress = () => {
  const client = useQueryClient();
  const instanceId = useInstanceId();
  return useMutation({
    mutationFn: putAddress,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: queryKey.addresses(instanceId) });
    },
  });
};
